export class PageErrorGlobalPresenter {
  form_error = {
    title: 'Lo sentimos',
    subtitle0: 'Tu operación no ha podido ser',
    subtitle1: 'realizada. Por favor, vuelve a',
    subtitle2: 'intentarlo mas tarde.',
    detail2: '',
    acceptButtonTitle: 'Entendido',
  };
}



